import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
// import AdminLogin from "./pages/AdminLogin";
// import AdminDashboard from "./pages/AdminDashboard";
function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/admin/login" element={<AdminLogin />} /> */}
            {/* <Route path="/admin" element={<AdminDashboard />} /> */}
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
export default App;
